<template>
  <div class="card card-content">

    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ contact.leader_firstname }} {{ contact.leader_lastname }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>

    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>

    <div class="card-block">
    <table class="table table-hover table-widget">
      <tbody>
      <tr v-for="(index, project) of projects" v-on:click="preview(project)" v-bind:class="{hidden:isActive(project)}">
        <td>{{ /* projectName(project) */ project.name }} {{ project.status }} - Entrée : <b>{{ project.first_meeting_date }}</b> | Sortie : {{ project.exit_date }}</td>
        <td class="text-xs-right">
            <button class="btn btn-primary" v-link="{ name: 'editProject', params: { projectId: project.id }}">Editer</button>
            <!-- <button class="btn btn-warning" @click="modalDelete(project)">Supprimer</button> -->
            <button class="btn btn-warning" v-on:click="remove(project)">Supprimer</button>
        </td>
      </tr>
      </tbody>
    </table>
    </div>

    <div class="Calendar"></div>

    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list'}">Voir tous les participants</a>
      </div>
    </div>
  </div>
</template>

<script>
  // Npm imports
  import $ from 'jquery'
  import moment from 'moment'

  // Vuex
  import { contact as currentContact, selectedDay } from 'src/vuex/getters'

  import { selectDay } from 'src/vuex/actions/meetingActions'
  import { getContact } from 'src/vuex/actions/contactActions'

  import { projects } from '../../vuex/getters'
  // import { getProjects } from '../../vuex/actions/projectActions'
  import { getProjectsOfContact } from '../../vuex/actions/contactActions'

  // Local components
  import Breadcrumb from '../nav/Breadcrumb.vue'

  import Modal from '../modals/Modal.vue'
  import DeleteProject from '../modals/DeleteProject.vue'

  export default {
    vuex: {
      getters: { currentContact, selectedDay, projects },
      actions: { getContact, selectDay, getProjectsOfContact }
    },
    components: {
      Breadcrumb,
      Modal,
      DeleteProject
    },
    data () {
      return {
        contact: []
      }
    },
    ready () {
      let vm = this

      this.getProjectsOfContact(this.$route.params.contactId)
        .then(() => vm.projects.forEach(function (project) {
          project.first_meeting_date = moment(project.first_meeting_date).format('DD-MM-YYYY')
          if (project.first_meeting_date === 'Invalid date') {
            project.first_meeting_date = ''
          }
          project.exit_date = moment(project.exit_date).format('DD-MM-YYYY')
          if (project.exit_date === 'Invalid date') {
            project.exit_date = ''
          }
        }))
      this
        .getContact(this.$route.params.contactId)
        .then(() => { vm.contact = JSON.parse(JSON.stringify(vm.currentContact)) })
    },
    methods: {
      isActive: function (project) {
        if (Number(project.contact_id) === Number(this.currentContact.id)) {
          // console.log(project.contact_id + ' === ' + this.currentContact.id)
          return ''
        } else {
          return true
        }
      },
      projectName: function (project) {
        let nameReturned
        // console.log('createName ' + project.name)
        if (project.project_type_id === '1') {
          nameReturned = 'ACA ' + project.name
        } else if (project.project_type_id === '2') {
          nameReturned = 'REGION ' + project.name
        } else if (project.project_type_id === '3') {
          nameReturned = 'COUVEUSE ' + project.name
        } else if (project.project_type_id === '4') {
          nameReturned = 'COUVEUSE MOSSON ' + project.name
        } else if (project.project_type_id === '5') {
          nameReturned = 'FORMATION CERTIFIANTE ' + project.name
        } else if (project.project_type_id === '6') {
          nameReturned = 'FORMATION AUTRES ' + project.name
        } else if (project.project_type_id === '7') {
          nameReturned = 'CLUB ' + project.name
        } else if (project.project_type_id === '8') {
          nameReturned = 'CAE ' + project.name
        } else if (project.project_type_id === '9') {
          nameReturned = 'PEPITE ' + project.name
        } else if (project.project_type_id === '1000') {
          nameReturned = 'AUTRE ' + project.name
        }
        return nameReturned
      },
      remove: function (project) {
        project = this.updateProjectList(project)
        this.deleteProject(project)
      },
      modalDelete (project) {
        this.projectToDelete = project
        this.showModal = true
      },
      executeBulkAction () {
        let that = this
        let projectToDelete = this.projects.filter(function (project) {
          return that.selected.indexOf(project.id.toString()) !== -1
        })

        switch (this.bulk_action) {
          case 'delete':
            this.projectsToDelete = projectToDelete
            this.showModalProjects = true
            break
        }
      }
    },
    events: {
      'deleteProject': function () {
        if (this.projectToDelete) {
          this.deleteProject(this.projectToDelete)
          this.projectToDelete = null
        }
      }
    },
    computed: {
    },
    watch: {
      'contact': function () {
        $('.Calendar').fullCalendar('refetchEvents')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ContactParcours.vue?2df7e13a